import { render, staticRenderFns } from "./TaskAllot.vue?vue&type=template&id=90cbde44&scoped=true&"
import script from "./TaskAllot.vue?vue&type=script&lang=js&"
export * from "./TaskAllot.vue?vue&type=script&lang=js&"
import style0 from "./TaskAllot.vue?vue&type=style&index=0&id=90cbde44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90cbde44",
  null
  
)

export default component.exports